import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import AlertService from "@/core/services/alert.service";
import router from '@/router'

// action types

export const PAGINATE_ALL_SMS_LOGS = "getPaginatedSmsLogs";
export const ALL_SMS_LOGS = "getAllSmsLogs";
export const CREATE_SMS_LOG_FORM = "createSmsLogForm";
export const DELETE_SMS_LOG = "deleteSmsLog";
export const GET_SMS_LOG_DATA = "getSmsLogData";
export const CREATE_SMS_LOG = "createSmsLog";
export const UPDATE_SMS_LOG = "updateSmsLog";


// mutation types

export const SET_PAGINATED_SMS_LOGS = "setPaginatedSmsLogs";
export const SET_ALL_SMS_LOGS = "setAllSmsLogs";
export const SET_SMS_LOG_DATA = "setSmsLogData";
export const SET_SMS_LOG_META = "setSmsLogMeta";
export const SET_SMS_LOG_ERROR = "setSmsLogError";
export const SET_SMS_LOG_LOADING = "setSmsLogLoading";
export const CLEAR_SMS_LOG_ERROR = "clearSmsLogError";
export const SET_IS_DISABLED_SMS_LOG = "setIsDisabledSmsLog";


const state = {
    sms_logs: [],
    paginatedSmsLogs: [],
    sms_log_data: {},
    meta_sms_log : {
        totalPages: 0,
        total: 0,
        from: 0,
        to: 0,
    },
    errors: [],
    loading: false,
    isDisabled: false
    };

const getters = {
   
    paginateAllSmsLogs(state) {
        return state.paginatedSmsLogs;
    },

    allSmsLogs(state) {
        return state.sms_logs;
    },

    getSmsLogData(state) {
        return state.sms_log_data;
    },

    meta_sms_log(state) {
        return state.meta_sms_log;
    },
    
};

const actions = {
 
    [PAGINATE_ALL_SMS_LOGS](context, payload) {
        context.commit(SET_IS_DISABLED_SMS_LOG, false);
        context.commit(SET_SMS_LOG_LOADING, true);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.get(`/sms_logs?size=${payload.itemsPerPage}&page=${payload.pageNumber}&sortBy=${payload.sortBy}&sortDesc=${payload.sortDesc}&searchText=${payload.search}&check=${payload.x}`)
        .then(({ data }) => {
            
            if(data == 403) {
                context.commit(SET_SMS_LOG_LOADING, false);
                router.push('nopermission');
            }
            else {
                context.commit(SET_PAGINATED_SMS_LOGS, data);
                context.commit(SET_SMS_LOG_META, data);
                context.commit(SET_SMS_LOG_LOADING, false);
            }
            
        })
        .catch(( response ) => {
            context.commit(SET_SMS_LOG_LOADING, false);
            context.commit(SET_SMS_LOG_ERROR, response.errors);
        });
        ;
        
    },

    [ALL_SMS_LOGS]() {
        return new Promise(resolve => {
            ApiService.get('/sms_logsAll')
            .then((response) => {
                resolve(response);
            })
        });
    },

    [CREATE_SMS_LOG_FORM](context) {
        context.commit(SET_SMS_LOG_LOADING, false);
        context.commit(SET_SMS_LOG_ERROR, false);
        context.commit(SET_IS_DISABLED_SMS_LOG, false);
    },

    [GET_SMS_LOG_DATA](context, payload) {
        context.commit(SET_IS_DISABLED_SMS_LOG, true);
        context.commit(SET_SMS_LOG_LOADING, true);
        context.commit(CLEAR_SMS_LOG_ERROR);
        return new Promise(resolve => {
            ApiService.get(`/sms_log/${payload.id}`)
            .then(( response ) => {
                if(response.data == 403) {
                    context.commit(SET_SMS_LOG_LOADING, false);
                    router.push('/nopermission');
                }
                else {
                    context.commit(SET_SMS_LOG_DATA, response.data);
                    context.commit(SET_SMS_LOG_LOADING, false);
                    context.commit(SET_IS_DISABLED_SMS_LOG, false);
                    resolve(response);
                }
            })
            .catch(({ response }) => {
                context.commit(SET_SMS_LOG_LOADING, false);
                context.commit(SET_SMS_LOG_ERROR, response.data.errors);
                context.commit(SET_IS_DISABLED_SMS_LOG, true);
            });
        });
    },

    [CREATE_SMS_LOG](context, payload) {
        context.commit(SET_SMS_LOG_LOADING, false);
        context.commit(SET_IS_DISABLED_SMS_LOG, true);
        context.commit(CLEAR_SMS_LOG_ERROR);
        return ApiService.post("/sms_log/store", payload.data)
        .then(( response ) => {
            if(response.data == 403) {
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde ekleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                context.commit(CLEAR_SMS_LOG_ERROR);
            }
            else{
                context.commit(SET_SMS_LOG_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Kayıt Başarılı",
                    "SMS Log başarıyla kaydedilmiştir. ID numarası: " + response.data.id
                );
                context.commit(CLEAR_SMS_LOG_ERROR);
                context.commit(SET_IS_DISABLED_SMS_LOG, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                return response;
            }
        })
        .catch(({ response }) => {
            context.commit(SET_SMS_LOG_LOADING, false);
            context.commit(SET_SMS_LOG_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_SMS_LOG, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
        });
    },

    [UPDATE_SMS_LOG](context, payload) {
        context.commit(SET_SMS_LOG_LOADING, true);
        context.commit(SET_IS_DISABLED_SMS_LOG, true);
        context.commit(CLEAR_SMS_LOG_ERROR);
        
        return ApiService.put(`/sms_log/${payload.data.id}`, payload.data)
        .then((response) => {
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                context.commit(SET_SMS_LOG_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Güncelleme Başarılı",
                    payload.data.id + " ID numaralı sms log başarıyla güncellenmiştir."
                );
            
                context.commit(SET_IS_DISABLED_SMS_LOG, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                
            return response;   
            }
                
        })
        .catch(({ response }) => {
            context.commit(SET_SMS_LOG_LOADING, false);
            context.commit(SET_SMS_LOG_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_SMS_LOG, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
            
        });
        
    },

    [DELETE_SMS_LOG](context, payload) {
        context.commit(SET_SMS_LOG_LOADING, true);
        context.commit(CLEAR_SMS_LOG_ERROR);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.delete(`/sms_log/${payload.itemToDelete}`)
        .then(( response ) => {
            context.commit(SET_SMS_LOG_LOADING, false);
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde silme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else {
                
                AlertService.makeToast(
                    "success",
                    "Silme Başarılı",
                    payload.itemToDelete + " ID numaralı sms log başarıyla silinmiştir."
                );
                
                
            }
        })
        .catch(( error ) => {
            context.commit(SET_SMS_LOG_ERROR, error);
            AlertService.makeToast(
                "warning",
                "Hata!",
                error
            );
        });
        
    },

    
    
};

const mutations = {

    [SET_PAGINATED_SMS_LOGS](state, paginatedSmsLogs) {
        state.paginatedSmsLogs = paginatedSmsLogs.data;
    },

    [SET_ALL_SMS_LOGS](state, sms_logs) {
        state.sms_logs = sms_logs;
    },

    [SET_SMS_LOG_DATA](state, sms_logs_data) {
        state.sms_logs_data = sms_logs_data;
        state.errors = [];
    },

    [SET_SMS_LOG_META](state, meta_sms_log) {
        state.meta_sms_log = meta_sms_log;
    },

    [SET_SMS_LOG_ERROR](state, error) {
        state.errors = error;
    },

    [CLEAR_SMS_LOG_ERROR](state) {
        state.errors = [];
    },
    
    [SET_SMS_LOG_LOADING](state, loading) {
        state.loading = loading;
    },

    [SET_IS_DISABLED_SMS_LOG](state, isDisabled) {
        state.isDisabled = isDisabled;
    },

};

export default {
    state,
    actions,
    mutations,
    getters
};
